import { render, staticRenderFns } from "./checkPlan.vue?vue&type=template&id=2106d506"
import script from "./checkPlan.vue?vue&type=script&lang=ts"
export * from "./checkPlan.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports